import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { JobRole, jobRolePermissions, jobRolePermissionsforSafetyVM, jobRoleSafety, MenuListVM } from '../../../entities';
import { AppService } from '../../../app.service';
import { UserService } from '../../../shared/services/user.service';
import { ConfigAddMontlyDashbrdMessageComponent } from '../config-add-montly-dashbrd-message/config-add-montly-dashbrd-message.component';
import { ConfigAddTakeComponent } from '../config-add-take/config-add-take.component';
import { ConfigAddToolboxTalkComponent } from '../config-add-toolbox-talk/config-add-toolbox-talk.component';
import { EnterSafetyInspectionDialogComponent } from '../enter-safety-inspection-dialog/enter-safety-inspection-dialog.component';




@Component({
  selector: 'app-home-new',
  templateUrl: './home-new.component.html',
  styleUrls: ['./home-new.component.scss']
})
export class HomeNewComponent implements OnInit {

  isAdministrator = false;
  isInterpreter = false;
  jobroleID:number
PermissionMneuData:jobRoleSafety;
PermissionMneuData_:jobRoleSafety[]=[];
menuL1:MenuListVM[]=[];
menuL2:MenuListVM[]=[];
menuL3:MenuListVM[]=[];

//menuList:jobRoleSafety[] =[ {ID:86,Name:"",Active:false}];

  constructor( private _user: UserService,
    private _notify: NotificationsService,
    private _router:Router,
    private _appService: AppService, 
    public dialog: MatDialog) { }

  ngOnInit() {
    this._appService.setPageTitle('Safety Home');
    this.getMenuforSelectedJobrole()
    this.checkMenu();
  }
  safetyDashbord_:boolean=false;
  generalDashbord_:boolean=false;
  safetyIndicators_:boolean=false;
  searchAndRevieForms_:boolean=false;
  entersafetyInspection_:boolean=false;
  searchSafetyInspections_:boolean=false;
  searchInductions_:boolean=false;
  performInduction_:boolean=false;
  selectForm_:boolean=false;
  uploadCompletedForms_:boolean=false;
  addTake5_:boolean=false;
  addToolBoxTalk_:boolean=false;
  addMonthlyDashboardMssage_:boolean=false;
  viewEditMonthlyHours_:boolean=false;
  setupInductinSlds_:boolean=false;
  setupInductionQuestions_:boolean=false;
  setupInductionTypesandSections_:boolean=false;
  setupDepartmentWorkAreas_:boolean=false;
  setupUsers_:boolean=false;
  setupIncidentTypes_:boolean=false;
  setupSafetyChecklist_:boolean=false;
  setupDigitalForms_:boolean=false;
 
  checkMenu(){  
     
  }


  getMenuforSelectedJobrole()
{ 
 
    this._user.jobRolePermissionsforSafetyVM().subscribe(r=> {
      console.log('result', r)
      this.PermissionMneuData_=r;
    })

console.log("this.PermissionMneuData", this.PermissionMneuData_)


let safetyDashbord = this.PermissionMneuData_.find(y=>y.ID==86);
if(safetyDashbord){
  this.safetyDashbord_=true;
}
let generalDashbord = this.PermissionMneuData_.find(y=>y.ID==85);
if(generalDashbord){
  this.generalDashbord_=true;
}
let safetyIndicators = this.PermissionMneuData_.find(y=>y.ID==89);
if(safetyIndicators){
  this.safetyIndicators_=true;
}
let searchAndRevieForms = this.PermissionMneuData_.find(y=>y.ID==87);
if(searchAndRevieForms){
  this.searchAndRevieForms_=true;
}
let entersafetyInspection = this.PermissionMneuData_.find(y=>y.ID==93);
if(entersafetyInspection){
  this.entersafetyInspection_=true;
}
let searchSafetyInspections = this.PermissionMneuData_.find(y=>y.ID==88);
if(searchSafetyInspections){
  this.searchSafetyInspections_=true;
}
let performInduction = this.PermissionMneuData_.find(y=>y.ID==95);
if(performInduction){
  this.performInduction_=true;
}
let searchInductions = this.PermissionMneuData_.find(y=>y.ID==96);
if(searchInductions){
  this.searchInductions_=true;
}

let selectForm = this.PermissionMneuData_.find(y=>y.ID==91);
if(selectForm){
  this.selectForm_=true;
}
let uploadCompletedForms = this.PermissionMneuData_.find(y=>y.ID==92);
if(uploadCompletedForms){
  this.uploadCompletedForms_=true;
}
let addTake5 = this.PermissionMneuData_.find(y=>y.ID==115);
if(addTake5){
  this.addTake5_=true;
}
let addToolBoxTalk = this.PermissionMneuData_.find(y=>y.ID==104);
if(addToolBoxTalk){
  this.addToolBoxTalk_=true;
}
let addMonthlyDashboardMssage = this.PermissionMneuData_.find(y=>y.ID==105);
if(addMonthlyDashboardMssage){
  this.addMonthlyDashboardMssage_=true;
}
let viewEditMonthlyHours = this.PermissionMneuData_.find(y=>y.ID==106);
if(viewEditMonthlyHours){
  this.viewEditMonthlyHours_=true;
}
let setupInductinSlds = this.PermissionMneuData_.find(y=>y.ID==99);
if(setupInductinSlds){
  this.setupInductinSlds_=true;
}
let setupInductionQuestions = this.PermissionMneuData_.find(y=>y.ID==98);
if(setupInductionQuestions){
  this.setupInductionQuestions_=true;
}
let setupInductionTypesandSections= this.PermissionMneuData_.find(y=>y.ID==97);
if(setupInductionTypesandSections){
  this.setupInductionTypesandSections_=true;
}
let setupDepartmentWorkAreas = this.PermissionMneuData_.find(y=>y.ID==101);
if(setupDepartmentWorkAreas){
  this.setupDepartmentWorkAreas_=true;
}
let setupUsers = this.PermissionMneuData_.find(y=>y.ID==120);
if(setupUsers){
  this.setupUsers_=true;
}
let setupIncidentTypes = this.PermissionMneuData_.find(y=>y.ID==103);
if(setupIncidentTypes){
  this.setupIncidentTypes_=true;
}
let setupSafetyChecklist = this.PermissionMneuData_.find(y=>y.ID==122);
if(setupSafetyChecklist){
  this.setupSafetyChecklist_=true;
} 

let setupDigitalForms = this.PermissionMneuData_.find(y=>y.ID==102);
if(setupDigitalForms){
  this.setupDigitalForms_=true;
}

}

  openSafetyInspectionDialog(){
    const dialogRef = this.dialog.open(EnterSafetyInspectionDialogComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  openConfigAddTakeDialog(){
    const dialogRef = this.dialog.open(ConfigAddTakeComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  //ConfigAddToolboxTalkComponent
  openConfigAddToolboxTalkDialog(){
    const dialogRef = this.dialog.open(ConfigAddToolboxTalkComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  //ConfigAddMontlyDashbrdMessageComponent
  openConfigAddMonthlyDashMessageDialog(){
    const dialogRef = this.dialog.open(ConfigAddMontlyDashbrdMessageComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }

  //navigate to perform Induction page
  NavigateToPerformInductionPage(){
    this._router.navigate(['/performinduction']);
  }

  //navigate to setup Induction Types and Section
  NavigateToSetupInductionTypesAndSectionPage(){
    this._router.navigate(['/configsetupinductionsection']);
  }
  NavigateToSetupInductionQuestion(){
    this._router.navigate(['/setup/inductionquestion']);
    
  }

  NavigateToSetupInductionSlide(){
    this._router.navigate(['/setupinductionslide']);
    
  }
  NavigateToSetupInductionSearch(){
    this._router.navigate(['/searchinduction']);
    
  }
  NavigateToSafetyInspectionSearch(){
    this._router.navigate(['/safetyinspection/search']);
  }

  NavigateToSafetyObservationPointDashbord(){
    this._router.navigate(['/safetyobservationdashboardcomponent']);

  }

  NavigateToSafetyIndicatorsComponent(){
    this._router.navigate(['/safetyindicatorscomponent']);

  }

  NavigateToSafetyGeneralDashboardComponent(){
    this._router.navigate(['/safetygeneraldashboardcomponent']);

  }

  NavigateToSetupForms(){
    this._router.navigate(['/configsetupforms']);
    
  }

  NavigateviewEditMonthlyHours(){
    this._router.navigate(['/configvieweditmonhr']);
    
  }
  NavigatSetupChecklist(){
    this._router.navigate(['/configsetupchecklist']);
    
  }
  NavigatconfigSetupDepartment(){
    this._router.navigate(['/configsetupdepartment']);
    
  }
 
  NavigatconfigSetupIncident(){
    this._router.navigate(['/configincident']);
    
  }

  NavigatUploadFroms(){
    this._router.navigate(['/form/uploadform']);
    
  }

NavigateTosearchform(){
  this._router.navigate(['/searchform']);

}
NavigateToselectform(){
  this._router.navigate(['/selectform']);

}

}

